import { styled as o } from "styled-components";
import { Theme as r } from "../../../../../styles/themes/index.js";
import { H3Heavy as t, BodyHeavy as e } from "../../../../../styles/typography/index.js";
const n = o.div`
  ${t}
  text-align: center;
  width: auto;
  color: rgb(${r.colors.Brand});
  white-space: nowrap;
  margin-right: 8px;

  small {
    ${e}
  }
`;
export {
  n as Container
};
